import Storage from './Storage'

import FakeParams from './FakeParams'
import axios from 'axios'
import Credentials from './Credentials'

class ActionTemplate extends Storage.Vue {

  static get name() {
    return 'action_templates'
  }

  constructor(vueOptions) {
    if (!vueOptions.timeout) {
      vueOptions.timeout = 500
    }
    if (!vueOptions.traits) {
      vueOptions.traits = {}
    }
    super({
      data: vueOptions,
      computed: {
        provides() {
          return this.outputNames.join(', ')
        },
        requires() {
          return this.inputNames.join(', ')
        },

        outputNames() {
          return Object.keys(this.output)
        },

        inputNames() {
          return Object.keys(this.input).concat(this.pathParams || [])
        },

        hasDefaultParams() {
          return !!(this.defaults && Object.keys(this.defaults).length > 0)
        },

        searchContent() {
          return JSON.stringify(this.$data).toLowerCase()
        }
      },

      methods: {
        humanDefaultData() {
          return FakeParams.apply(this.defaults)
        }
      }
    })
  }

  static default() {
    return new ActionTemplate({method: 'POST', input: {}, output: {}, defaults: {}, endpoint: "", name: ""})
  }

}



export default ActionTemplate